import { createContext, useContext, useState } from 'react';

export const PageBackgroundContext = createContext();

export const PageBackgroundProvider = ({ children }) => {
	const [video, setVideo] = useState(null);
	const [image, setImage] = useState(null);
	const [tinted, setTinted] = useState(true);
	const [masked, setMasked] = useState(true);
	const [caption, setCaption] = useState(null);
	const [isLightbox, setIsLightbox] = useState(false);
	const [maskOpacity, setMaskOpacity] = useState(1.0);
	const [hasReveal, setHasReveal] = useState(false);
	const [hasSponsoredby, setHasSponsoredby] = useState(false);
	const [graphics, setGraphics] = useState(false);

	return (
		<PageBackgroundContext.Provider
			value={{
				video,
				setVideo,
				image,
				setImage,
				tinted,
				setTinted,
				masked,
				setMasked,
				caption,
				setCaption,
				isLightbox,
				setIsLightbox,
				maskOpacity,
				setMaskOpacity,
				hasReveal,
				setHasReveal,
				hasSponsoredby,
				setHasSponsoredby,
				graphics,
				setGraphics,
			}}
		>
			{children}
		</PageBackgroundContext.Provider>
	);
};

const usePageBackground = () => {
	return useContext(PageBackgroundContext);
};

export default usePageBackground;
